module.exports = __webpack_public_path__ + "img/CM-MC-25-Buick-Modern.9aa3c21b.jpg";